<content-loading *ngIf="isLoading"></content-loading>

<form autocomplete="off" *ngIf="state.get('data').size" class="form px-4">
  <form-row
    [canDelete]="!isReadonly"
    (onDelete)="onDelete(i)"
    *ngFor="let contact of contacts; let i = index"
  >
    <div class="columns mb-0">
      <div class="column is-3">
        <div class="field">
          <label class="label" translationEditableDirective="CONTACT_TITLE">{{
            'CONTACT_TITLE' | translate
          }}</label>
          <div class="control">
            <ng-select
              class="is-small"
              *ngIf="!isReadonly"
              [items]="contactTitles"
              name="contactTitle"
              [multiple]="false"
              [closeOnSelect]="true"
              (change)="
                handleFieldChange($event, [i, 'contact'], 'contactTitle')
              "
              [ngClass]="{ 'is-danger': hasError('contactTitle') }"
              bindLabel="name"
              [typeahead]="onContactTitlesAutocomplete$"
              [ngModelOptions]="{ standalone: true }"
              [ngModel]="contact.getIn(['contact', 'contactTitle']) | array"
            >
            </ng-select>
            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'contactTitle', 'name']) || '-'
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('contactTitle')">
            {{ getError('contactTitle') }}
          </p>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label" translationEditableDirective="FIRST_NAME">{{
            'FIRST_NAME' | translate
          }}</label>
          <div class="control">
            <input
              *ngIf="!isReadonly"
              class="input is-small"
              name="firstName"
              type="text"
              (input)="handleFieldChange($event, [i, 'contact'])"
              [value]="contact.getIn(['contact', 'firstName'])"
              [ngClass]="{ 'is-danger': hasError('firstName') }"
            />
            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'firstName'])
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('firstName')">
            {{ getError('firstName') }}
          </p>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label" translationEditableDirective="LAST_NAME">{{
            'LAST_NAME' | translate
          }}</label>
          <div class="control">
            <input
              *ngIf="!isReadonly"
              class="input is-small"
              name="lastName"
              type="text"
              (input)="handleFieldChange($event, [i, 'contact'])"
              [value]="contact.getIn(['contact', 'lastName'])"
              [ngClass]="{ 'is-danger': hasError('lastName') }"
            />
            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'lastName'])
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('lastName')">
            {{ getError('lastName') }}
          </p>
        </div>
      </div>
      <div class="column is-3"></div>
    </div>
    <div class="columns mb-0">
      <div class="column is-3">
        <div class="field">
          <label class="label" translationEditableDirective="CONTACT_TYPE">{{
            'CONTACT_TYPE' | translate
          }}</label>
          <div class="control">
            <ng-select
              class="is-small"
              *ngIf="!isReadonly"
              [items]="contactTypes"
              name="contactType"
              [multiple]="false"
              [closeOnSelect]="true"
              (change)="handleFieldChange($event, [i], 'contactType')"
              [ngClass]="{ 'is-danger': hasError('contactType') }"
              bindLabel="name"
              [typeahead]="onContactTypesAutocomplete$"
              [ngModel]="contact.get('contactType') | array"
              [ngModelOptions]="{ standalone: true }"
            >
            </ng-select>
            <span *ngIf="isReadonly">{{
              contact.getIn(['contactType', 'name']) || '-'
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('contactType')">
            {{ getError('contactType') }}
          </p>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label" translationEditableDirective="PHONE_NUMBERS">{{
            'PHONE_NUMBERS' | translate
          }}</label>
          <div class="control">
            <tag-input
              *ngIf="!isReadonly"
              class="is-small"
              [secondaryPlaceholder]="'ADD_PHONE_NUMBERS' | translate"
              placeholder=""
              (onAdd)="onAdd($event, [i, 'contact'], 'phoneNumbers')"
              (onRemove)="onRemove($event, [i, 'contact'], 'phoneNumbers')"
              [addOnBlur]="true"
              name="phoneNumbers"
              [ripple]="false"
              [separatorKeys]="separatorKeys"
              [ngModelOptions]="{ standalone: true }"
              [ngModel]="contact.getIn(['contact', 'phoneNumbers'])"
            ></tag-input>
            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'phoneNumbers']).join(', ')
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('phoneNumbers')">
            {{ getError('phoneNumbers') }}
          </p>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-3">
        <div class="field">
          <label class="label" translationEditableDirective="EMAIL">{{
            'EMAIL' | translate
          }}</label>
          <div class="control">
            <input
              *ngIf="!isReadonly"
              class="input is-small"
              name="email"
              type="text"
              (input)="handleFieldChange($event, [i, 'contact'])"
              [value]="contact.getIn(['contact', 'email'])"
              [ngClass]="{ 'is-danger': hasError('email') }"
            />
            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'email']) || '-'
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('email')">
            {{ getError('email') }}
          </p>
        </div>
      </div>
      <div class="column is-6">
        <div class="field">
          <label class="label" translationEditableDirective="TAX_ID">{{
            'TAX_ID' | translate
          }}</label>
          <div class="control">
            <input
              *ngIf="!isReadonly"
              class="input is-small"
              name="taxId"
              type="text"
              (input)="handleFieldChange($event, [i, 'contact'])"
              [value]="contact.getIn(['contact', 'taxId'])"
              [ngClass]="{ 'is-danger': hasError('taxId') }"
            />
            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'taxId']) || '-'
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('taxId')">
            {{ getError('taxId') }}
          </p>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label" translationEditableDirective="PRINCIPAL_CONTACT"
            >{{ 'PRINCIPAL_CONTACT' | translate }}
            <i
              *ngIf="isReadonly && contact.get('principalContact')"
              class="fas fa-check has-text-success"
            ></i
          ></label>
          <div class="control">
            <div class="switch" *ngIf="!isReadonly" style="margin-top: 14px">
              <label>
                <input
                  [disabled]="isReadonly"
                  [checked]="contact.get('principalContact')"
                  [ngClass]="{ 'is-danger': hasError('principalContact') }"
                  (change)="switch($event, [i])"
                  class="switch-input"
                  name="principalContact"
                  type="checkbox"
                />
                <div><div></div></div>
              </label>
            </div>

            <span *ngIf="isReadonly">{{
              contact.getIn(['contact', 'principalContact'])
            }}</span>
          </div>
          <p class="help is-danger" *ngIf="hasError('principalContact')">
            {{ getError('principalContact') }}
          </p>
        </div>
      </div>
    </div>
  </form-row>
  <form-row [canDelete]="false" *ngIf="contacts.size === 0"></form-row>
  <div *ngIf="!isReadonly" style="margin-bottom: 20px">
    <button
      type="button"
      (click)="this.cd.reattach(); isAddContactOpen = true"
      class="button is-info px-2"
    >
      <svg
        width="23px"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z"
        />
      </svg>
    </button>
  </div>
</form>

<div class="modal is-active" *ngIf="isAddContactOpen">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 350px">
    <div class="modal-card-head">
      <span
        class="modal-card-title"
        [translationEditableDirective]="ADD_CONTACT"
      >
        {{ 'ADD_CONTACT' | translate }}
      </span>
      <button
        class="delete"
        (click)="isAddContactOpen = false"
        aria-label="close"
      ></button>
    </div>
    <form
      class="modal-card-body p-5"
      style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px"
    >
      <div class="field">
        <div class="control">
          <ng-select
            [items]="existingContacts"
            [multiple]="false"
            [closeOnSelect]="true"
            bindLabel="fullName"
            (change)="selectedContact = $event"
            bindValue="id"
            [ngModelOptions]="{ standalone: true }"
            [ngModel]="contactConnectionValue"
            [typeahead]="onContactAutocomplete$"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-index="index"
              let-search="searchTerm"
            >
              <div>{{ item.fullName }} ({{ item.taxId || 'No ID' }})</div>
            </ng-template>
          </ng-select>
          <button
            [disabled]="!selectedContact"
            class="button is-success is-fullwidth mt-3"
            type="button"
            translationEditableDirective="USE_SELECTED"
            (click)="onRowAdd(selectedContact); isAddContactOpen = false"
          >
            {{ 'USE_SELECTED' | translate }}
          </button>
        </div>
      </div>
      <div
        class="has-text-centered mb-5 mt-4"
        translationEditableDirective="OR"
      >
        {{ 'OR' | translate }}
      </div>
      <div class="field">
        <div class="control">
          <button
            class="button is-success is-fullwidth"
            type="button"
            translationEditableDirective="CREATE_NEW_CONTACT"
            (click)="onRowAdd(); isAddContactOpen = false"
          >
            {{ 'CREATE_NEW_CONTACT' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
